import { QueryClientProvider } from '@tanstack/react-query';
import i18n from 'i18next';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { toLanguage } from './i18n.js';
// Fonts and both themes of the new design (SP-UX10.1); the controls come in through styles.css.
import '../../../design/foundation/fonts.css';
import '../../../design/foundation/tokens.css';
import './styles.css';
import { countPageViews } from './pageViews.js';
import { router } from './router.js';
import { createQueryClient } from './session.js';

const queryClient = createQueryClient();

const root = document.getElementById('root');
if (root) {
  // The own visitor counter (SP-D16): no cookie, no address stored.
  countPageViews(router, () => toLanguage(i18n.resolvedLanguage));
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
